<app-featuress
  bgImage="moul.png"
  bannerText=""
 >
</app-featuress>

<app-share-video-demo
 sectionTitle="লাইভ সফটওয়্যার দেখতে এখানে ক্লিক করুন"
  thumbnailUrl="live.png"
  [isVideo]="false"
  [showButton]="true"
  buttonText="লাইভ সফটওয়্যার দেখুন"
  buttonLink="https://www.youtube.com/watch?v=rCCVGi_h3nA"> 
</app-share-video-demo>
<app-cards></app-cards>
<app-money-back-slider></app-money-back-slider>




